import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function MarkAsPickedUpDialog({ open, onClose, onConfirm, orders = [] }) {
  const [comment, setComment] = useState("");

  const handleConfirm = () => onConfirm(comment);

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Mark as picked up</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to mark {orders?.length === 1 ? 'this order' : `these ${orders?.length} orders`} as picked up?
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Additional comments"
          helperText="The information you enter here will be included in the order detail within Shopify. This applies to all orders you have selected."
          type="text"
          fullWidth
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          sx={{ mt: 4 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}